export default function getErrorMessage(error: any) {
  if (!error) {
    return 'Unknown error';
  }

  const { status, message } = error;
  return status && message ? `${status} ${message}` : error.toString();
}
